import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import sun1 from './img/sun1.png';
import sun2 from './img/sun2.png';
import sun3 from './img/sun3.png';
import car_logo from './img/car_logo.png';
import gift from './img/gift.png';
import { useMediaQuery } from "react-responsive";

import ray_img from './img/ray.png';
import casper_img from './img/casper.png';

import casper_bg from './img/casper_bg.png';
import ray_bg from './img/ray_bg.png';
import ray_icon from './img/ray_icon.png';


function Casper({setBannerType}){
    const history = useHistory();

    const [carType, setCar] = useState('casper')
    useEffect(()=> {
        setBannerType('casper')

        return () => {
            if(window.location.href === 'http://localhost:3000/' || window.location.href === 'https://abys-service.co.kr/'){
                setBannerType('main');
            }
        }
    },[carType])

    console.log('carType : ', carType)
    const onClick = (typed) => {
        setBannerType('')
        history.push(`sunlist?type=${typed}&car=casper`)
    }

    const isPc = useMediaQuery({
        query : "(min-width:768px)"
    });
    const isMobile = useMediaQuery({
        query : "(max-width:767px)"
    });

    return (
        <div className="k-wrapper py-5">
            <div>
                <p className="container top-title font-weight-bold mb-5" style={{color:'#585858',fontSize:'16px'}}>
                썬가드하이퍼 신차패키지는 고객님 차량의 품격을 높여주는 서비스 입니다.<br />
                썬팅에서 블랙박스, 유리막코팅, PPF까지...고품질의 서비스를 합리적인 가격으로 만나보세요! 
                </p>
            </div>
            <div className="container">
                <div className="clearfix">
                    <img src={car_logo} className="float-left" style={{width:'30%',maxWidth:'200px'}}/>
                    {
                        isMobile
                        ?<p className="sun-text font-weight-bold" style={{fontSize:'14px'}}><span style={{color:'#1E4EA0',fontSize:'17px'}}>썬가드하이퍼</span>와 함께하는 <br/><span style={{color:'#E85415',fontSize:'17px'}}>캐스퍼</span> 신차패키지</p>
                        :<p className="sun-text font-weight-bold" style={{fontSize:'18px'}}><span style={{color:'#1E4EA0',fontSize:'19px'}}>썬가드하이퍼</span>와 함께하는 <span style={{color:'#E85415',fontSize:'19px'}}>캐스퍼</span> 신차패키지</p>
                    }
                    
                </div>
                <div className="row p-0" style={{margin:'0 -15px'}}>
                    <div className="col-6 col-md-4 mb-5"><img className="w-100 pointer" src={sun1} onClick={() => onClick('SMART')}/></div>
                    <div className="col-6 col-md-4 mb-5"><img className="w-100 pointer" src={sun2} onClick={() => onClick('Premium')}/></div>
                    <div className="col-6 col-md-4"><img className="w-100 pointer" src={sun3} onClick={() => onClick('Prestige')}/></div>
                </div>
                <div className="mt-5">
                    {
                        isMobile
                        ?<img src={gift} className="float-left mr-3 mb-3" style={{width:'25px'}}/>
                        :<img src={gift} className="float-left mr-3 mb-3" style={{width:'30px'}}/>
                        
                    }
                    {
                        isMobile
                        ? <p className="gift-text font-weight-bold mb-0" style={{color:'#00479D',fontSize:'14px'}}>ABYS So Good Service (모든 패키지 무상제공)</p>
                        : <p className="gift-text font-weight-bold mb-0" style={{color:'#00479D',fontSize:'16px'}}>ABYS So Good Service (모든 패키지 무상제공)</p>
                    }
                
                    <div className="clear"></div>
                    <div className="row">
                        <p className="col-6 bottom-title font-weight-bold">- 신차검수</p>
                        <p className="col-6 bottom-title font-weight-bold">- 실내 향균탈취 (피톤치드)</p>
                        <p className="col-6 bottom-title font-weight-bold">- 고급 가죽 등록증 케이스</p>
                        <p className="col-6 bottom-title font-weight-bold">- 가죽 키홀더</p>
                        <p className="col-6 bottom-title font-weight-bold">- 가죽 키 케이스</p>
                        <p className="col-6 bottom-title font-weight-bold">- 가죽 전화번호 패드</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Casper;